import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

type Props = {
    placeholder: string;
    choices: string[];
    value: string;
    onChange: (value: string) => void;
};

const BasicSelect: React.FC<Props> = ({ placeholder, choices, value, onChange }) => {
    const handleChange = (event: SelectChangeEvent) => {
        onChange(event.target.value);
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel id="simple-select-label">{placeholder}</InputLabel>
                <Select id="simple-select" value={value} label={placeholder} onChange={handleChange}>
                    {choices.map((choice: string) => (
                        <MenuItem key={choice} value={choice}>
                            {choice}
                        </MenuItem>
                    ))}
                    ;
                </Select>
            </FormControl>
        </Box>
    );
};

export default BasicSelect;
